export interface PaletteEntry {
  name: string;
  utility: string;
  hexLight: string;
  hexDark: string;
}

// Values mirror the Flywrite brand palette (--fw-* variables) defined once
// in app/frontend/styles/design-system.css. Keep the two in sync.
export const SURFACES: PaletteEntry[] = [
  {
    name: "page",
    utility: "bg-page",
    hexLight: "#fefefe",
    hexDark: "#081220",
  },
  {
    name: "surface",
    utility: "bg-surface",
    hexLight: "#eef6fb",
    hexDark: "#122031",
  },
  {
    name: "hairline",
    utility: "border-hairline",
    hexLight: "#c6d7e3",
    hexDark: "#24374c",
  },
];

export const TEXT: PaletteEntry[] = [
  {
    name: "ink-body",
    utility: "text-ink-body",
    hexLight: "#2a3545",
    hexDark: "#dbe8ef",
  },
  {
    name: "ink-display",
    utility: "text-ink-display",
    hexLight: "#081220",
    hexDark: "#eef6fb",
  },
  {
    name: "ink-muted",
    utility: "text-ink-muted",
    hexLight: "#5a7184",
    hexDark: "#9ca6b0",
  },
];

export const SPLASH: PaletteEntry[] = [
  {
    name: "accent",
    utility: "bg-accent / text-accent",
    hexLight: "#00c78e",
    hexDark: "#00c78e",
  },
  {
    name: "accent-faded",
    utility: "bg-accent-faded",
    hexLight: "#ccfbe7",
    hexDark: "#0d3230",
  },
  {
    name: "accent-display",
    utility: "bg-accent-display / text-accent-display",
    hexLight: "#00694d",
    hexDark: "#00e7b0",
  },
  {
    name: "link",
    utility: "text-link / ring-link",
    hexLight: "#2c97f5",
    hexDark: "#63b3f8",
  },
  {
    name: "signal",
    utility: "bg-signal / text-signal",
    hexLight: "#ffc02e",
    hexDark: "#ffc02e",
  },
  {
    name: "signal-faded",
    utility: "bg-signal-faded",
    hexLight: "#fdeaba",
    hexDark: "#2f2a17",
  },
  {
    name: "signal-display",
    utility: "bg-signal-display / text-signal-display",
    hexLight: "#6e5716",
    hexDark: "#ecd28a",
  },
  {
    name: "danger",
    utility: "bg-danger / text-danger",
    hexLight: "#e25c5c",
    hexDark: "#e25c5c",
  },
  {
    name: "danger-faded",
    utility: "bg-danger-faded",
    hexLight: "#fae3e3",
    hexDark: "#391d1d",
  },
  {
    name: "danger-display",
    utility: "bg-danger-display / text-danger-display",
    hexLight: "#7c2d2d",
    hexDark: "#f09a9a",
  },
];

export const FONTS = {
  display: "Scope One",
  body: "Hind",
  mono: "JetBrains Mono",
};
